import './App.css';
import {
    Button,
    Col,
    Divider,
    Flex,
    FloatButton,
    Input,
    message,
    Row,
    Select,
    Space,
    Table,
    Tag,
} from 'antd';
import useSWR from 'swr';
import { Typography } from 'antd';
import {
    SetStateAction,
    useEffect,
    useState,
} from 'react';
import type { TableProps } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import copy from 'copy-to-clipboard';
import Loading from './Loading';

const { Title, Text } = Typography;

interface DataType {
    id: number;
    key: string;
    name: string;
    artist: string;
    categories: string;
}

const fetcher = async (url: string) => {
    const res = await fetch(url, {
        headers: new Headers({
            'Access-Control-Allow-Origin': '*',
        }),
    });
    const json = await res.json();
    if (!json.success) {
        const error = new Error((await json).message);
        throw error;
    }
    return json;
};

const TableRow = (props: any) => {
    return (
        <tr
            {...props}
            onClick={() => {
                copy(
                    `点歌${props.children[0].props.record.name}(${props.children[0].props.record.artist})`
                );
                message.success('复制完成，快去直播间点歌吧~');
            }}
        />
    );
};

const Song = () => {
    const { data, error, isLoading } = useSWR(
        'https://api.lynne.com.cn/songList/list',
        fetcher
    );
    const [filterData, setFilterData] = useState<any[]>([]);
    const columns: TableProps<DataType>['columns'] = [
        {
            title: '歌名',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '歌手',
            dataIndex: 'artist',
            key: 'artist',
        },
        {
            title: '分类',
            key: 'categories',
            dataIndex: 'categories',
            render: (_, { categories }) => (
                <>
                    {categories.split(',').map(tag => {
                        return (
                            <Tag color='blue' key={tag}>
                                {tag.toUpperCase()}
                            </Tag>
                        );
                    })}
                </>
            ),
        },
    ];
    const [searchText, setSearchText] = useState('');
    const [searchCategory, setSearchCategory] = useState([]);
    const handleSearch = (e: { target: { value: SetStateAction<string> } }) => {
        setSearchText(e.target.value);
    };
    const handleCategory = (value: any, option: any) => {
        setSearchCategory(value);
    };

    useEffect(() => {
        if (data && data.data) {
            setFilterData(
                data.data.filter((item: any) => {
                    if (searchText !== '') {
                        if (
                            item.name.indexOf(searchText) === -1 &&
                            item.artist.indexOf(searchText) === -1
                        ) {
                            return false;
                        }
                    }
                    if (searchCategory.length !== 0) {
                        let contain = false;
                        searchCategory.forEach(category => {
                            if (
                                item.category_id
                                    .split(',')
                                    .map((i: string) => parseInt(i))
                                    .includes(category)
                            ) {
                                contain = true;
                            }
                        });
                        if (!contain) {
                            return false;
                        }
                    }
                    return true;
                })
            );
        }
    }, [data, searchCategory, searchText]);
    const selectRandom = () => {
        if (filterData.length !== 0) {
            const item = filterData[Math.floor(Math.random()*filterData.length)];
            copy(`点歌${item.name}(${item.artist})`);
            message.success(`选中了${item.name}(${item.artist})，已经自动复制了点歌弹幕喔，粘贴发送就可以啦`)
        }
    }
    if (isLoading) return <Loading />;
    if (error) return <div>failed to load</div>;

    // 渲染数据
    return (
        <>
            <Flex align='center' justify='middle'>
                <Title level={2} style={{ margin: '15px 0', flex: 1 }}>
                    玲奈歌单~
                </Title>
            </Flex>
            <Text style={{ fontSize: '20px' }}>
                这里收录了玲奈会唱的歌曲喔，点击表格里的歌曲就可以复制点歌弹幕啦~
            </Text>
            <Divider />
            <Space
                direction='vertical'
                style={{ margin: '20px 0', width: '100%' }}>
                <Row gutter={[12, 12]}>
                    <Col flex={'1 1'}>
                        <Input
                            placeholder='搜索歌曲'
                            onChange={handleSearch}
                            prefix={<SearchOutlined />}
                        />
                    </Col>
                    <Col flex={'1 1'}>
                        <Select
                            mode='multiple'
                            placeholder='类别筛选'
                            allowClear
                            style={{ width: '100%' }}
                            onChange={handleCategory}
                            options={data.categories.map(
                                (category: { id: number; name: string }) => {
                                    return {
                                        value: category.id,
                                        label: category.name,
                                    };
                                }
                            )}
                        />
                    </Col>
                    <Col flex={'0 1'}>
                        <Button type='primary' onClick={selectRandom}>随机选择</Button>
                    </Col>
                </Row>
                {searchText !== '' && (
                    <Text>
                        当前展示“{searchText}”的搜索结果，共{filterData.length}
                        首
                    </Text>
                )}
            </Space>
            <Table<DataType>
                components={{
                    body: { row: TableRow },
                }}
                columns={columns}
                dataSource={filterData}
                pagination={{ position: ['none', 'none'] }}
            />
            <FloatButton.BackTop />
        </>
    );
};

export default Song;
